import { type ReactNode } from 'react';
import cx from 'clsx';

import './styles.scss';

type DataListProps = Readonly<{
  className?: string;
  children?: ReactNode;
}>;

export const DataList = ({ className, children }: DataListProps) => (
  <div className={cx('DataList', className)}>{children}</div>
);

export const DataListItem = ({ className, children }: DataListProps) => (
  <div className={cx('DataList-item', className)}>{children}</div>
);
